import Vue from "vue";

export async function fetchBook({ commit }, id) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/library/${id}`
    });
    commit("library/setBook", data, { root: true });
  } catch (e) {
    commit("booksError", e.message);
  } finally {
  }
}

export async function fetchCategories({ commit }) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/library/get_categories`
    });
    commit("library/setCategories", data, { root: true });
  } catch (e) {
    commit("categoriesError", e.message);
  } finally {
  }
}

export async function requestBook({ commit }, book) {
  try {
    await Vue.axios({
      method: "POST",
      url: `/frontend/library/create_request_book`,
      data: {
        book_id: book.id
      }
    });
  } catch (e) {
    commit("booksError", e.message);
  } finally {
    // console.log("La petición para actualizar el anuncio ha finalizado");
  }
}
